export const COLORS = {
  dark: {
    DEFAULT: { value: '#101010' },
    text: { value: '#1E1E1E' },
    cardTitle: { value: '#101828' },
    900: { value: '#2D264B' },
  },
  light: {
    DEFAULT: { value: '#ffffff' },
    200: { value: '#faf7f7' },
    300: { value: '#F3F3F3' },
    400: { value: '#EDEDED' },
    500: { value: '#F3F4F9' },
  },
  gray: {
    DEFAULT: { value: '#98A2B3' },
    400: { value: '#F5F4F3' },
    500: { value: '#CDCDCD' },
    600: { value: '#676767' },
    700: { value: '#667085' },
    800: { value: '#475467' },
  },
  link: {
    DEFAULT: { value: '#ED3237' },
  },
};
